import React, {useMemo} from "react";
import {getUserRemainPeriodDisplay} from "../userAccountRemainPeriod";

function UserAccountRemainPeriodLabel({user}) {
    const display = useMemo(() => getUserRemainPeriodDisplay(user), [user]);

    if (!display) {
        return null;
    }

    return (
        <span className={`user-account-check-list__remain user-account-check-list__remain--${display.tone}`}>
            {display.text}
        </span>
    );
}

function UserAccountManageSidebarList({
    items = [],
    selectedId,
    checkedIds = [],
    onSelect,
    onToggleCheck,
    onToggleAll,
}) {
    const checkedSet = useMemo(() => new Set(checkedIds), [checkedIds]);
    const allChecked = items.length > 0 && items.every((item) => checkedSet.has(item.id));
    const someChecked = items.some((item) => checkedSet.has(item.id));

    return (
        <div className="user-account-check-list">
            <div className="user-account-check-list__toolbar">
                <label className="user-account-check-list__select-all">
                    <input
                        type="checkbox"
                        checked={allChecked}
                        ref={(el) => {
                            if (el) {
                                el.indeterminate = !allChecked && someChecked;
                            }
                        }}
                        onChange={(e) => onToggleAll?.(e.target.checked)}
                    />
                    <span>사용자 목록</span>
                </label>
                {checkedIds.length > 0 && (
                    <span className="user-account-check-list__count">{checkedIds.length}건 선택</span>
                )}
            </div>

            <div className="user-account-check-list__scroll code-manage-scroll-area">
                {!items?.length ? (
                    <p className="user-account-check-list__empty">검색 결과가 없습니다.</p>
                ) : (
                    <ul className="user-account-check-list__items">
                        {items.map((item) => {
                            const isSelected = selectedId === item.id;
                            const isChecked = checkedSet.has(item.id);
                            const companyName = item.company?.name;
                            const departmentName = item.department?.name;

                            return (
                                <li
                                    key={item.id}
                                    className={`user-account-check-list__item${isSelected ? " is-selected" : ""}${isChecked ? " is-checked" : ""}`}
                                >
                                    <label
                                        className="user-account-check-list__checkbox"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={() => onToggleCheck?.(item.id)}
                                        />
                                    </label>
                                    <button
                                        type="button"
                                        className="user-account-check-list__body"
                                        onClick={() => onSelect(item)}
                                    >
                                        <div className="user-account-check-list__name-row">
                                            <span className="user-account-check-list__name">{item.name}</span>
                                            <UserAccountRemainPeriodLabel user={item} />
                                        </div>
                                        <span className="user-account-check-list__meta">
                                            {[item.username, companyName, departmentName].filter(Boolean).join(" · ")}
                                        </span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default UserAccountManageSidebarList;
